import React, { FC } from "react";
import type { PaymentOrchestrationUniversalPaymentAccountProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const PaymentOrchestrationUniversalPaymentAccount: FC<
  PaymentOrchestrationUniversalPaymentAccountProps
> = ({ content, cover }) => {
  return (
    <section className="paymentOrchestrationUniversalPaymentAccount">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={766} />
      </div>
      <div className="wrapper wrapper_lg">
        {cover.file?.url && (
          <Image
            className="paymentOrchestrationUniversalPaymentAccount--cover"
            src={cover as any}
            alt={cover.title}
            animateInView
          />
        )}
      </div>
    </section>
  );
};
